import type { IconData } from '@stacksjs/iconify-core'

export const programmingBug: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M13 9.5V11h3v4a4 4 0 0 1-3.437-1.953a5.001 5.001 0 0 1-9.126 0A4 4 0 0 1 0 15v-4h3V9.5H0v-3h3V5H0V1c1.46 0 2.739.783 3.437 1.953a5.001 5.001 0 0 1 9.126 0A4 4 0 0 1 16 1v4h-3v1.5h3v3z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default programmingBug
